<template>
  <div class="sucess" >
     <div class="suc">
            <img class='close' src="../../static/images/closeicon.png" alt="" @click='cancel'>
            <img class='sucicon' src="../../static/images/sucessicon.png" alt="">
            <p class='word'>{{sucess}}</p>
            <a class='tjline' href="#">查看推荐路线</a>
            <p class='smword'>您也可以点击查看其他可订制线路</p>
        </div>
  </div>
</template>
<script>
export default {
  props: {
    sucess: {
      default: () => {
        return '订制旅行申请成功，请耐心等待'
      },
      type: String,
      required: false
    }
  },
  methods: {
    cancel () {
      this.$parent.cancel()
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/sucess/ordersucess.vue